export const oldDomainAws = 'https://ancient.pcworth.com';

export const oldSites = {
  buildsGallery: `${oldDomainAws}/builds-gallery`,
  buildGalleryDetails: `${oldDomainAws}/builds-gallery/details`, // NOTE: Concat slug / id  eg: https://www.pcworth.com/builds-gallery/details/fc362af4-eb09-4adb-8990-6b37d7cb98ec
  pricelist: `${oldDomainAws}/pricelist`,
};
